/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#459796"/>
    <path d="M18 7.875L9.75 16.125L6 12.375" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>


);

export default SvgComponent;
